module.exports = __webpack_public_path__ + "static/img/超速.00bfaa51.png";